import { render, staticRenderFns } from "./TimeAttendanceOffSiteLocationAdd.vue?vue&type=template&id=98a1f942"
import script from "./TimeAttendanceOffSiteLocationAdd.vue?vue&type=script&lang=js"
export * from "./TimeAttendanceOffSiteLocationAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports